export default "__VITE_ASSET__D7MZJNX0__"